import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/**
 * The Data Gateway's `get<Schema>s` queries take native `where` / `order` / `paging` arguments
 * instead of a single JSON-string `input: DynamicQueryInput` — see graphql-query-builder.ts for
 * why these are inlined as literals rather than passed as typed variables. Paged lists sort on the
 * server (`buildOrderLiteral`), so each page is a slice of the sorted whole.
 *
 * Schema: ToilRequest (verified against SCHEMA_REFERENCE.json — same
 * entity hr-my-toil writes).
 *
 * Latest TOIL day first by default, like the old manager lists' default `{ ToilDateUTC: -1 }` sort.
 */
export const DEFAULT_MANAGE_TOIL_REQUESTS_ORDER: OrderBy[] = [
  { field: 'ToilDate', direction: 'DESC' },
];

export const buildGetToilRequestsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_MANAGE_TOIL_REQUESTS_ORDER
) => `
  query {
    ToilRequests: getToilRequests(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        UserId
        DisplayName
        Email
        DepartmentId
        DepartmentName
        DepartmentKey
        ToilDate
        ToilType
        Duration
        Reason
        Status
        IsArchived
        CreatedDate
        Note
        ToilCategory
      }
    }
  }
`;
